import validator from "validator";

export function validatePirateDriverForm(formData) {
    const errors = {};
    if (!validator.isLength(formData.driverName, { min: 2 })) {
        errors.driverName = "Sürücü adı en az 2 karakter olmalıdır.";
    }
    const cleanedPhone = formData.driverPhone.replace(/\s+/g, '');
    if (!validator.isMobilePhone(cleanedPhone, 'tr-TR')) {
        errors.driverPhone = "Geçerli bir telefon numarası girin.";
    }
    if (!validator.isLength(formData.vehiclePlate, { min: 7, max: 9 })) {
        errors.vehiclePlate = "Geçerli bir plaka girin.";
    }
    if (!validator.isLength(formData.dorse, { min: 7, max: 9 })) {
        errors.dorse = "Geçerli bir dorse plakası girin.";
    }
    if (!validator.isNumeric(formData.cost.toString())) {
        errors.cost = "Maliyet sayısal bir değer olmalıdır.";
    } else if (formData.cost <= 0) {
        errors.cost = "Maliyet 0'dan büyük olmalıdır.";
    }

    return errors;
}
